export const leftArrow = (
    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M5.5 11L10.5 16L11.562 14.938L7.375 10.75H16.5V9.25H7.375L11.562 5.062L10.5 4L4.5 10L5.5 11Z" fill="#58585A"/>
    </svg>
)


